import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

// Theme Provider
import { ThemeProvider } from './context/ThemeContext';
import { useTheme } from './hooks/useTheme';

// Layout
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/common/ScrollToTop';

// Bestehende Seiten
import HomePage from './pages/HomePage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';

// Neue Section-Seiten
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ApproachPage from './pages/ApproachPage';
import FAQPage from './pages/FAQPage';
import ContactPage from './pages/ContactPage';

function AppContent() {
  const [isLoading, setIsLoading] = useState(true);
  const { theme, isDark } = useTheme();

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ backgroundColor: theme.colors.background.primary }}
      >
        <div className="text-center">
          <div className="spinner mx-auto mb-4"></div>
          <p className="font-serif text-lg" style={{ color: theme.colors.primary[600] }}>
            Einen Moment bitte...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`min-h-screen flex flex-col ${isDark ? 'dark' : ''}`}
      style={{ backgroundColor: theme.colors.background.primary }}
    >
      <ScrollToTop />
      <Navbar />

      <main className="flex-grow">
        <AnimatePresence mode="wait">
          <Routes>
            {/* Bestehende Routen */}
            <Route path="/"            element={<HomePage />} />
            <Route path="/impressum"   element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />

            {/* Neue Section-Routen */}
            <Route path="/ueber-mich"   element={<AboutPage />} />
            <Route path="/angebot"      element={<ServicesPage />} />
            <Route path="/arbeitsweise" element={<ApproachPage />} />
            <Route path="/faq"          element={<FAQPage />} />
            <Route path="/kontakt"      element={<ContactPage />} />
          </Routes>
        </AnimatePresence>
      </main>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;